import { FC, ReactNode } from 'react';
import { Box } from '@gemini/fe-ds-core';

interface GridCellProps {
  children?: ReactNode;
}

const GridCell: FC<GridCellProps> = ({ children }) => (
  <Box
    display='flex'
    flexDirection='column'
    justifyContent='center'
    height="100%"
  >
    {children}
  </Box>
);

export default GridCell;
